/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendScenarioDto } from '../../models/backend-scenario-dto';
import { BackendScenarioRequestDto } from '../../models/backend-scenario-request-dto';

export interface ProjectCalculationsVariantsKitsCreate$FormData$Params {
  body: BackendScenarioRequestDto;
}

export function projectCalculationsVariantsKitsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsVariantsKitsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendScenarioDto>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsVariantsKitsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendScenarioDto>;
    }),
  );
}

projectCalculationsVariantsKitsCreate$FormData.PATH = '/api/project_calculations/variants_kits/';
